import { Anchor, Stack, Text, Title } from "@mantine/core";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router";
import { NavBarContainer } from "./NavBarContainer";

const DATA_LINKS = [
  { to: "/data/labelsnap", labelKey: "labelSnap" },
  { to: "/data/etisys", labelKey: "etisys" },
  { to: "/data/etisyserrors", labelKey: "etisysErrors" },
  { to: "/data/labelsnaperrors", labelKey: "labelSnapErrors" },
  { to: "/data/labelsnapwarnings", labelKey: "labelSnapWarnings" },
  { to: "/data/labelsnapserver", labelKey: "labelSnapServer" },
] as const;

export function DataHubPage() {
  const { t } = useTranslation();

  return (
    <NavBarContainer variant="marketing" title={t("data.title")}>
      <Stack gap="sm">
        {DATA_LINKS.map((l) => (
          <Anchor key={l.to} component={Link} to={l.to}>
            {t(`data.${l.labelKey}`)}
          </Anchor>
        ))}
        <Anchor component={Link} to="/admin">
          {t("data.backAdmin")}
        </Anchor>
      </Stack>
    </NavBarContainer>
  );
}

export function DataStubPage() {
  const { t } = useTranslation();
  const params = useParams();

  return (
    <NavBarContainer variant="marketing" title={t("data.title")}>
      <Stack gap="md">
        <Title order={4}>{params.section}</Title>
        <Text>{t("data.notImplemented")}</Text>
        <Anchor component={Link} to="/data">
          {t("data.back")}
        </Anchor>
      </Stack>
    </NavBarContainer>
  );
}
